{
    "TITLE" : "Remote 应用",
        "SHARED": {
            "INTERNET_OFFLINE": "您的网络连接似乎处於离线状态。",
            "LANGUAGE": "语言",
            "NO_FEATURE": "您的授权不包含此功能。 请联系您的管理员。",
            "FEATURE_UNAVAILABLE": "您的授权不包含此功能。",
            "APP_UPDATE_NEEDED": "To use this feature, this participant needs to update their app.",
            "TRAINING_DISABLED": "您没有权限使用此功能。 请向主持人申请许可。"
        },
        "UPDATE_MODAL": {
            "TITLE": "有可用的更新",
            "MESSAGE": "有新版本可用。 此页面将在更新後重新加载。",
            "UPDATE": "重新加载",
            "UPDATE_FAILED": "更新失败"
        },
        "LOGIN" : {
        "SSO-BUTTON": "使用 SSO 登录",
            "APP_NAME": "{{ appName }} Remote",
            "TITLE": "登入 Remote 应用",
            "ACCOUNT_PLACEHOLDER" : "帐户名称",
            "ACCOUNT_REQUIRED" : "帐户名称是必需的。",
            "ACCOUNT_SHORT" : "帐户名称必须至少为 2 个字符。",
            "USERNAME_PLACEHOLDER" : "用户名称",
            "USERNAME_REQUIRED" : "用户名称是必需的。",
            "USERNAME_SHORT" : "用户名称必须至少为 2 个字符。",
            "PASSWORD_PLACEHOLDER" : "密码",
            "PASSWORD_REQUIRED" : "密码是必需的。",
            "PASSWORD_SHORT" : "密码必须至少6个字符。",
            "REMEMBER_ACCOUNT_NAME": "记住账户名称",
            "VERIFICATION_CODE": "验证码",
            "TWO_FACTOR_EMAIL_SENDED": "我们已向您发送了一封包含验证码的电子邮件。",
            "VERIFY_BUTTON": "确认",
            "LOGIN_BUTTON" : "登入",
            "BACK_BUTTON" : "日耳曼",
            "BEFORE_TERMS": "点击登入，即表示您同意我们的",
            "TERMS": "服务条款",
            "CONJUNCTION": "和",
            "PRIVACY": "隐私政策",
            "AFTER_PRIVACY": "。",
            "GUEST_DELETED": "您已退出。",
            "USER_DELETED": "您的帐户已被删除。 请联系您的管理员。",
            "USER_DISABLED": "您的帐户已被禁用。 请联系您的管理员。",
            "LOGGED_IN_ANOTHER_SESSION": "您已登录另一个会议。",
            "LOGGED_OUT_UNKNOWN": "哎呀！出了错！",
            "NO_INTERNET_ERROR": "连接中断。 请检查您的网络连接。",
            "USERNAME_PASSWORD_ERROR" : "帐户名称丶用户名称或密码错误。",
            "ACCOUNT_DISABLED": "您的帐户已过期。 请联系 {{ contactMail }}",
            "INVALID_VERIFICATION_CODE" : "两步验证码无效。",
            "UNKNOWN_ERROR" : "登录时发生错误。",
            "SIMULTANE_LOGIN_ERROR": "您已登录另一个会议。",
            "USE_CHINA_SERVERS": "我从中国登录",
            "CHINA_SERVERS_CAUTION": "此选项可能会导致中国大陆以外的延迟。",
            "MULTI_LOGIN_MODAL": {
                "TITLE": "多重登录",
                "MESSAGE": "您的用户已在另一台设备上登录。 如果您继续，其他设备将被退出。",
                "CANCEL": "取消",
                "PROCEED": "继续"
            }
        },
        "MAIN" : {
            "LICENSE_LEFT": "您的 {{ appName }} Remote 许可证还剩 {{ days }} 天。",
            "DEMO_LEFT": "您的 {{ appName }} Remote 试用期还剩 {{ days }} 天。",
            "LEFT_BAR": {
                "LOBBY": "大堂",
                "ROOMS": "专室",
                "MEETINGS": "会议",
                "FEEDBACK": "反馈",
                "CONTACTS": "用户",
                "SESSIONS": "會話",
                "TICKETS": "工单",
                "PRECALL_TEST": "预通话测试",
                "WHATS_NEW": "什么是新的",
                "PROFILE": "简介",
                "HELP_CENTER": "服务台",
                "LOGOUT": "退出"
            },
            "CALL_MESSAGE": {
                "TITLE":"来电来自 <strong>{{ caller_name }}</strong>",
                "DENY": "拒绝",
                "ACCEPT": "接受"
            },
            "GET_EXPORT_MODAL": {
                "TITLE": "获取会议导出",
                "MESSAGE1": "请输入您的电子邮件地址以在会议结束後接收会议导出下载链接。",
                "MESSAGE2": "会议导出将包括会议中共享的所有聊天消息丶快照丶视频通话记录和文件。",
                "EXPORT_NAME_NOT_LOCKED": "您可以通过输入自定义文件名来重命名导出文件。",
                "EXPORT_NAME_LOCKED": "其他用户完成导出后，您将能够重命名导出文件。",
                "EXPORT_NAME_RENAMED": "导出文件被此用户重命名：",
                "EXPORT_NAME_PLACEHOLDER": "出口名称",
                "NOTE": "注意：您可以从配置文件菜单更新您的电子邮件地址。",
                "NOTE2": "注意：您可以通过管理员更新您的电子邮件地址。",
                "OPEN_PROFILE": "打开个人资料",
                "EMAIL": "电子邮件",
                "EMAIL_REQUIRED": "电子邮件是必需的。",
                "EMAIL_INVALID": "电子邮件格式无效。",
                "CLOSE": "关闭",
                "SEND": "发送",
                "EXPORT_SUCCEEDED": "会议导出将在会议结束後发送。",
                "ENDED_SESSION_EXPORT_SUCCEEDED": "会话导出已发送。",
                "EXPORT_FAILED": "发生错误。"
            },
            "EASY-ACCESS": {
                "MANAGE-PUBLIC-ACCESS": "管理公共访问",
                "MANAGE-PUBLIC-ACCESS-TEXT": "您可以通过删除公共访问来停止共享此工作流。",
                "GENEATE-ACCESS-TEXT": "您可以生成公共链接和二维码来为此工作流创建便捷访问。",
                "ENABLE-PASSWORD": "启用密码",
                "GENERATE-ACCESS": "生成",
                "LINK": "链接",
                "COPY": "复制",
                "QR-CODE": "二维码",
                "DOWNLOAD": "下载",
                "SECURITY": "安全",
                "PASSWORD-PROTECTED": "密码保护",
                "PUBLIC": "公开",
                "DELETE-ACCESS": "删除公共访问",
                "EASY-ACCESS-TITLE": "{{ shortName }} 工作流便捷访问",
                "OPEN-WORKFLOW-NAME": "您即将打开",
                "GUEST-EMAIL": "访客邮箱",
                "REQUIRED": "此字段为必填项",
                "GUEST-PASSWORD": "访客密码",
                "OPEN": "打开",
                "OPEN-APP": "我们建议在我们的应用中打开此工作流以获得更好的体验。",
                "COPY-LINK-TEXT": "将链接复制到剪贴板，以便在应用启动时打开此工作流。",
                "DOWNLOAD-APP": "下载应用",
                "DOWNLOAD-SMARTGLASSES-APP": "下载智能眼镜应用",
                "OR": "或",
                "CONTINUE-WITH-BROWSER": "在浏览器中继续",
                "PASSWORD-PROTECTED-TEXT": "启用密码后，拥有公共链接或二维码的用户只有在输入密码后才能访问此工作流。",
                "CREATE-PASSWORD": "创建密码",
                "ENTER-EMAIL": "输入您的邮箱",
                "ENTER-WORKFLOW-PASSWORD": "输入工作流密码",
                "DELETE-QR-TEXT": "要更改便捷访问的安全类型，您应该删除便捷访问并重新生成。",
                "LOADING-WORKFLOW": "正在加载工作流...",
                "UNABLE-TO-LOAD": "无法加载工作流",
                "RETRY": "重试",
                "GUEST-ACCESS": {
                    "TOKEN-MISSING": "令牌缺失或无效",
                    "ID-MISSING": "工作流ID或基础URL缺失",
                    "WORKFLOW-NOT-PUBLISHED": "工作流未发布",
                    "PUBLIC-ACCESS": "公共访问已存在",
                    "NO-PUBLIC-ACCESS": "无公共访问"
                },
                "QR-INFORMATION": "二维码信息"
            },
            "VIDEO-FLOW-DASHBOARD": {
                "TITLE": "视频流程",
                "CREATE-VIDEO-FLOW": "创建视频流程",
                "CREATED-BY-AI": "由人工智能创建",
                "VERSION": "版本",
                "NO-VIDEO-FLOWS-FOUND": "未找到视频流程",
                "CLEAR-ALL": "清除全部",
                "CONFIRM-VIDEO": "确认视频",
                "CONFIRM-VIDEO-TITLE": "确认视频转换",
                "CONFIRM-VIDEO-MESSAGE": "您确定要将此视频流程转换为工作流程吗？确认后，您将无法编辑视频。",
                "CONFIRM-VIDEO-BUTTON": "确认并转换",
                "MAKE-WORKFLOW-SUCCESSFUL": "成功转换为工作流程",
                "MAKE-WORKFLOW-ERROR": "转换为工作流程失败",
                "UPLOAD-VIDEO-DESCRIPTION": "上传您的视频以自动生成分步工作流程指南。",
                "VIDEO-DURATION-LIMIT": "视频时长不能超过30分钟。",
                "VIDEO-UPLOADED-SUCCESS": "视频上传成功！",
                "SELECT-VIDEO": "选择视频",
                "CHANGE-VIDEO": "更改视频",
                "CREATE-BUTTON": "创建",
                "AI-PROCESSING": "AI处理中",
                "SPLITTING-VIDEO": "将视频分割成片段",
                "TRANSCRIBING-VIDEO": "转录视频内容",
                "PROCESS-WARNING": "此过程可能需要10分钟。请不要关闭此窗口。"
            },
            "NAVBAR" : {
                "PRECALL_TEST": "预通话测试",
                "PRECALL_END_SESSION": "请在预通话测试前结束会议。",
                "LOGOUT" : "退出",
                "LANGUAGE" : "语言",
                "LOGOUT_MODAL_TITLE": "退出？",
                "LOGOUT_MODAL_MESSAGE": "这将使您退出。",
                "CAUTION": "注意：这会在不结束会话的情况下将您注销。会话后的弹出窗口和其他信息可能会丢失（例如会话导出）！",
                "LOGOUT_MODAL_MESSAGE_IN_ROOM": "您将离开会话并注销。",
                "LOGOUT_MODAL_NO": "取消",
                "LOGOUT_MODAL_YES": "退出",
                "LOGOUT_FAILED": "退出时发生错误",
                "HELP_CENTER": "服务台",
                "PROFILE_TITLE": "简介",
                "PROFILE_NAME": "名称",
                "PROFILE_EMAIL": "电子邮件",
                "PROFILE_PASSWORD": "密码",
                "PROFILE_CHANGE_LINK": "更改",
                "PROFILE_ADD_LINK": "添加",
                "PROFILE_CLOSE": "关闭",
                "CHANGE_PASS_TITLE": "更改密码",
                "CHANGE_PASS_OLD_PASS": "旧密码",
                "CHANGE_PASS_NEW_PASS": "新密码",
                "CHANGE_PASS_RPT_PASS": "确认密码",
                "CHANGE_PASS_REQUIRED": "密码是必需的。",
                "CHANGE_PASS_NOT_MATCH": "密码不匹配",
                "CHANGE_PASS_CLOSE_BTN": "关闭",
                "CHANGE_PASS_CHANGE_BTN": "更改密码",
                "CHANGE_PASS_SUCCESS": "您的密码已更改。",
                "CHANGE_PASS_WRONG": "您的密码错误。",
                "CHANGE_PASS_FAILED": "密码更改失败。",
                "CHANGE_EMAIL_TITLE": "更改电子邮件",
                "CHANGE_EMAIL_NEW_EMAIL": "新邮件",
                "CHANGE_EMAIL_RPT_EMAIL": "确认电子邮件",
                "CHANGE_EMAIL_REQUIRED": "电子邮件是必需的.",
                "CHANGE_EMAIL_NOT_VALID": "电子邮件无效.",
                "CHANGE_EMAIL_NOT_MATCH": "电子邮件地址不匹配.",
                "CHANGE_EMAIL_CLOSE_BTN": "关闭",
                "CHANGE_EMAIL_CHANGE_BTN": "更改电子邮件",
                "CHANGE_EMAIL_SUCCESS": "您的电子邮件已更改.",
                "CHANGE_EMAIL_FAILED": "电子邮件更改失败.",
                "FEEDBACK": "Feedback",
                "SUCCESS_MESSAGE": "感谢您提交表格。我们的团队会尽快回复您。",
                "CLOSE": "关闭",
                "CREATE_NEW_PASS": "密码要求",
                "UPPERCASE": "大写",
                "LOWERCASE": "小写",
                "NUMBER": "数字",
                "SPECIAL": "特别的",
                "AT_LEAST_PASSWORD_LENGTH": "至少 {{ passwordlength }} 个字符",
                "OLD_PASSWORD": "旧密码",
                "NOT_WHITESPACE": "您的密码不得包含空格字符",
                "DO_NOT_CREATE_SIMPLE": "不要创建像“123456”这样的弱密码",
                "STATUS": {
                    "AVAILABLE": "可用的",
                    "BUSY": "忙碌的",
                    "APPEAR_OFFLINE": "顯示為離線"
                }
            },
            "LOBBY" : {
                "LOBBY_SHARED": {
                    "ONGOING_CALLS_TITLE": "正在进行的通话",
                    "ROOMS_TITLE" : "您的专室",
                    "UPCOMING_MEETINGS_TITLE" : "即将召开的会议",
                    "PREVIOUS_MEETINGS_TITLE" : "以前的会议",
                    "SCHEDULE_MEETING": "安排会议",
                    "INSTANT_GUEST_ACCESS": "即时访客访问",
                    "INSTANT_GUEST_ACCESS_NO_CALLING": "您没有通话权限。请联系管理员。",
                    "INSTANT_GUEST_ACCESS_NO_GUEST_ACCESS": "您没有创建访客访问链接的权限。请联系管理员。",
                    "INSTANT_GUEST_ACCESS_NO_PERM": "您没有通话或创建访客访问链接的权限。请联系管理员。",
                    "LINK_UNAVAILABLE": "链接不可用",
                    "JOIN" : "加入",
                    "CANCEL": "取消",
                    "REMOVE": "去掉",
                    "NO_ROOM": "你没有任何专室。",
                    "NO_MEETING": "你没有任何会议。",
                    "NO_PREV_MEETING": "你没有任何会议。",
                    "NO_OTHER_USERS": "没有其他用户。",
                    "SHOW_MORE": "显示 {{ count }} 多",
                    "SHOW_LESS": "显示较少"
                },
                "SCHEDULE_MEETING_MODAL": {
                    "TITLE": "安排会议",
                    "MEETING_TITLE": "标题*",
                    "MEETING_TITLE_REQUIRED": "标题必填。",
                    "START_DATE": "开始",
                    "END_DATE": "End",
                    "CLOSE": "关闭",
                    "SCHEDULE_SEND": "安排和发送",
                    "SCHEDULE": "日程",
                    "CANNOT_SCHEDULE": "安排会议时出错。",
                    "CANNOT_CANCEL_MEETING": "取消会议时出错。",
                    "ENTER_USERS": "输入用户",
                    "SEND_INVITATIONS": "发送邀请",
                    "INVITATION_EMAIL_LANG": "邀请邮件语言",
                    "SHARE_AFTER": "会议链接也可以在安排后共享。"
                },
                "CANCEL_MEETING_MODAL": {
                    "CANCEL_TITLE": "取消会议",
                    "REMOVE_TITLE": "删除会议",
                    "CANCEL_MESSAGE": "您确定要取消会议吗？",
                    "REMOVE_MESSAGE": "确定要删除会议吗？",
                    "CLOSE": "关闭",
                    "PROCEED": "继续"
                },
                "CONTACTS": {
                    "TITLE": "用户",
                    "NO_PERMISSION": "您没有权限查看联系人和通话。",
                    "NO_CONTACT": "用户列表为空。",
                    "SELECT_MULTI": "选择多个",
                    "CALL": "通话",
                    "ADMIN": "管理员",
                    "COADMIN": "共同管理员",
                    "EXPERT": "专家",
                    "SUBSCRIBER": "订户",
                    "USER": "用户",
                    "NAME": "名称",
                    "USERNAME": "用户名称",
                    "ROLE": "角色",
                    "NO_EXPERT": "请至少选择一位专家进行通话。",
                    "NAME_USERNAME": "姓名或用户名",
                    "ALL_ROLES": "所有角色"
                },
                "SESSIONS": {
                    "TITLE": "會話",
                    "DATE": "创建於",
                    "DURATION": "总持续时间",
                    "ROOM_NAME": "专室",
                    "NO_SESSIONS": "會話列表為空。",
                    "PARTICIPANTS": "参与者",
                    "EXPORT": "出口",
                    "STATUS": "狀態",
                    "ON_GOING": "進行中",
                    "ENDED": "結束",
                    "FILES": "文件",
                    "CHAT": "聊天",
                    "SESSION_FILES": {
                        "MULTIPLE_SELECTION": "选择多个",
                        "DOWNLOAD": "下载",
                        "DOWNLOAD_STARTED_SOON": "下载将很快开始。",
                        "DOWNLOAD_FAILED": "下载失败。",
                        "NO_FILE_IS_ADDED": "在此會話中未添加或協作任何文件。",
                        "SUCCESS_MESSAGE": "文件已成功下载。"
                    },
                    "ATTACHED_TICKET": "附票",
                    "SESSION_DETAILS": "會話詳細信息",
                    "BACK": "後退",
                    "GET_SESSION_EXPORT": "獲取會話導出",
                    "ATTACH_TO_TICKET": "附加到票證"
                },
                "TICKETS": {
                    "TITLE": "工单",
                    "NEW_TICKET": "新工单",
                    "ALL_ROOMS": "所有专室",
                    "ALL_STATUSES": "所有状态",
                    "NO_TICKETS": "工单列表为空。",
                    "TICKET_TITLE": "标题",
                    "ROOM": "专室",
                    "CREATED_BY": "创建者",
                    "CREATED_ON": "创建於",
                    "STATUS": "状态",
                    "STATUS_OPEN": "开放",
                    "STATUS_IN_PROGRESS": "进行中",
                    "STATUS_CLOSED": "关闭",
                    "CLOSE_PICK_TICKET": "关闭",
                    "CREATE_NEW": "创建新的",
                    "ATTACH": "附上",
                    "CREATE_TICKET": "创建工单",
                    "TICKET_DETAILS": "工单详情",
                    "EDIT": "编辑",
                    "TICKET_TYPE": "工单类型",
                    "ROOM2": "专室： ",
                    "CREATED_BY2": "创建者： ",
                    "CREATED_ON2": "创建於： ",
                    "ROOM3": "专室",
                    "STATUS2": "状态",
                    "PRIORITY": "优先",
                    "ASSIGNEE": "代理人",
                    "FOLLOW_UP": "跟进日期",
                    "TICKET_TITLE2": "标题",
                    "TITLE_REQUIRED": "标题为必填项",
                    "DESCRIPTION": "描述",
                    "DESCRIPTION_REQUIRED": "描述为必填项",
                    "RESOLUTION": "决议",
                    "ATTACHED_SESSIONS": "附加会议",
                    "NO_ATTACHED_SESSIONS": "附加会议列表为空",
                    "SESSION_COUNT": "会议次数： ",
                    "TOTAL_DURATION": "总持续时间： ",
                    "PARTICIPANTS2": "参与者：",
                    "COUNT_SESSIONS": " {{count}} 会议",
                    "DATE": "日期",
                    "ROOM_NAME": "专室名称",
                    "PARTICIPANTS": "参与者：",
                    "DURATION": "持续时间",
                    "GUEST": "（来宾）",
                    "CANCEL": "取消",
                    "CLOSE": "关闭",
                    "SAVE": "保存",
                    "CREATE": "创建",
                    "CREATED_BETWEEN": "创建于",
                    "ALL_CREATORS": "所有创作者",
                    "SEND_VIA_EMAIL": "通过电子邮件发送",
                    "DELETE_TICKET": "删除票",
                    "DELETE_TICKET_MODAL": {
                        "TITLE": "删除工单？",
                        "MESSAGE":"您确定要删除工单 <strong>{{title}}</strong> 吗？",
                        "CANCEL": "取消",
                        "DELETE": "删除"
                    },
                    "LOW": "低的",
                    "MEDIUM": "中等的",
                    "HIGH": "高的",
                    "CHOOSE_TICKET": "选择门票",
                    "ERRORS": {
                        "TICKET_ALREADY_ATTACHED": "门票已附上。",
                        "ERROR_OCCURED": "发生错误。",
                        "PERMISSION_DENIED": "没有权限。",
                        "MISSING_PARAMETERS": "缺少参数",
                        "FILE_ALREADY_EXIST": "文件已存在"
                    },
                    "FILES": "文件",
                    "UPLOAD_FILE": "上传文件"
                },
                "ARCHIVES": {
                    "ARCHIVE_LIST": {
                        "LOADING": "加载中",
                        "CREATED_AT": "创建於",
                        "SIZE": "大小",
                        "STATUS": "状态",
                        "DOWNLOAD": "下载",
                        "AVAILABLE": "可用",
                        "DISCONNECTED": "已中断",
                        "DELETED": "已删除",
                        "EXPIRED": "已到期",
                        "WAITING": "等待中",
                        "FAILED": "已失败",
                        "REFRESH": "刷新",
                        "NO_ARCHIVE_MESSAGE": "沒有視頻通話記錄",
                        "NAME": "姓名",
                        "STORAGE": "貯存",
                        "DURATION": "期間",
                        "ARCHIVES": "視頻通話記錄",
                        "PLAY": "玩",
                        "DELETE": "刪除",
                        "DOWNLOAD_ARCHIVE": {
                            "TITLE": "下載記錄",
                            "GENERATING": "生成下載",
                            "GENERATED": "下載 關聯 生成",
                            "CANNOT_GENERATED": "無法生成下載 關聯。",
                            "DOWNLOAD": "下載",
                            "CLOSE": "關閉"
                        },
                        "DELETE_ARCHIVE": {
                            "TITLE": "刪除記錄",
                            "MESSAGE": "視頻通話記錄將被刪除。",
                            "CAUTION": "注意：此記錄也將從您的 Azure 存儲中刪除。",
                            "CANCEL": "取消",
                            "DELETE": "刪除"
                        }
                    }
                },
                "CONVERTER": {
                    "TITLE": "转换器",
                    "STP_ONLY": "仅支持 .stp 和 .step 文件格式.",
                    "ERROR_UPLOAD": "上传文件时发生错误.",
                    "DRAG": "将您的文件拖放到此处",
                    "OR": "或者",
                    "CHOOSE": "选择文件",
                    "CONVERT": "兑换",
                    "SUPPORTED": "支持的文件格式：",
                    "BACK": "后退",
                    "DOWNLOAD": "下载",
                    "ERROR_LOAD": "加载对象时发生错误."
                },
                "WHATSNEW": {
                    "WHATSNEW_TITLE": "什么是新的",
                    "NO_UNREAD_UPDATE": "没有未读更新"
                },
                "JOIN_MODAL": {
                    "JOIN" : "加入",
                    "CALL": "通话",
                    "CANCEL": "取消",
                    "MIRROR_VIDEO": "镜像视频",
                    "PREFERRED_RESOLUTION": "首选分辨率",
                    "RESOLUTION_NOTE": "注意：如果您的设备不支持您请求的分辨率，将使用下一个最大的分辨率。",
                    "CAM_MIC_PERM_REQUIRED": "需要存取摄像头和麦克风",
                    "CAM_MIC_PERM_DENIED": "无法存取您的摄像头或麦克风",
                    "CAM_MIC_CANT_ACCESS": "我们无法存取您的摄像头或麦克风",
                    "JOIN_CAM_OFF": "加入时将摄像头设置为关",
                    "JOIN_MIC_OFF": "加入时将麦克风设置为关",
                    "JOIN_CAM_MIC_OFF": "加入时将摄像头和麦克风设置为关",
                    "JOIN_NO_DEVICE": "无需摄像头和麦克风即可加入",
                    "ALLOW_ACCESS": "您需要在浏览器设置中允许访问您的摄像头和麦克风（授予访问权限后，您仍然可以关闭摄像头或麦克风）。",
                    "TRY_AGAIN": "重试/刷新页面并在浏览器提示时选择“允许”。"
                },
                "NO_DEVICE_MODAL": {
                    "TITLE": "未找到设备",
                    "JOIN_BODY": "此设备没有连接麦克风和摄像头。 其他用户将无法通过此设备听到或看到您。 你还想加入吗？",
                    "CALL_BODY": "此设备没有连接麦克风和摄像头。 其他用户将无法通过此设备听到或看到您。 你还想打电话吗？",
                    "CANCEL": "取消",
                    "JOIN": "无论如何加入",
                    "CALL": "无论如何打电话"
                },
                "AGREEMENT_MODAL": {
                    "TITLE": "关於个人数据传输的承诺",
                    "REJECTION_BUTTON": "拒绝",
                    "AGREEMENT_BUTTON": "同意"
                },
                "CHECK_AGREEMENT_MODAL": {
                    "TITLE": "取消合同？",
                    "ERROR": "发生错误。",
                    "STATEMENT": "当您不接受合同时，您将无法登录系统。",
                    "CANCEL_BUTTON": "取消",
                    "PROCEED_BUTTON": "继续"
                },
                "JOIN_UNKNOWN_ERROR" : "加入专室时发生错误。",
                "JOIN_CONCURRENT_ERROR" : "您已达到并行用户限制。 请联系您的管理员了解更多详情。",
                "JOIN_EXPERT_CONCURRENT_ERROR": "您已达到并行专家用户限制。 请联系您的管理员了解更多详情。",
                "NO_TRAINING_LICENSE": "您的培训室许可证有问题。 请联系您的管理员。",
                "TRAINING_LICENSE_EXPIRED": "您的培训室许可证已过期。 请联系您的管理员。",
                "ASK_TRAINING_HOST": "加入训练室时发生错误。 请联系主持人。",
                "JOIN_CALL_IN_PROGRESS": "您的个人会议室中有另一个通话。",
                "NOT_SUPPORTED_TITLE": "不兼容的浏览器",
                "NOT_SUPPORTED_MESSAGE": "您的浏览器不兼容。 请使用 Google Chrome丶Mozilla Firefox丶Safari 或 Microsoft Edge（版本 79 或更高版本）。",
                "NO_IOS_MESSAGE": "您的浏览器不兼容。 请使用 {{ appName }} Remote 应用或使用 Safari。",
                "IOS_VERSION_MESSAGE": "您的浏览器不兼容。 请使用 {{ appName }} Remote 应用程序。",
                "NOT_SUPPORTED_CLOSE": "关闭",
                "IDLE_MODAL_TITLE": "错误",
                "IDLE_MODAL_MESSAGE": "你很长一段时间没有任何交流。",
                "IDLE_MODAL_COUNT": "您将在 {{ count }} 秒後退出。",
                "IDLE_MODAL_OK": "我回来了",
                "ARCHIVE_PERMISSION_MODAL": {
                    "TITLE": "允许录制吗？",
                    "MESSAGE": "在这个专室里的会议将被记录下来。 您需要允许视频录制才能加入此专室。",
                    "DENY": "拒绝",
                    "ALLOW": "允许"
                }
            },
            "ROOM" : {
                "OT_ERROR_MODAL": {
                    "TITLE": "错误",
                    "CLOSE": "继续",
                    "REJOIN": "重新加入",
                    "ENDCALL": "离开",
                    "ERRORS": {
                        "INTERNET": "无法连接会议。 请检查您的网络连接。",
                        "TRY_AGAIN": "连接会议时发生错误。 请稍後再试。",
                        "UNKNOWN": "连接会议时发生错误。",
                        "PUBLISHER_FAILED": "无法与其他参与者共享您的视频信息流。",
                        "PUBLISHER_CAM_MIC_ACCESS": "确保您的摄像头和麦克风正常工作并授予摄像头/麦克风权限。",
                        "SUBSCRIBER_FAILED": "无法连接到参与者视频信息流之一。"
                    }
                },
                "SIDEBAR" : {
                    "CHAT_TITLE" : "聊天",
                    "PARTICIPANTS_TITLE" : "参与者",
                    "FILES_TITLE" : "文件",
                    "SETTINGS_TITLE" : "设置",
                    "SHOW_TICKET": "显示工单",
                    "ATTACH_TO_TICKET": "附加到工单",
                    "ATTACH_SESSION_TO_TICKET": "将会议附加到工单",
                    "OPEN_WORKFLOW": "打開工作流程",
                    "CHAT" : {
                        "SEE_TRANSLATION": "查看翻译",
                        "SEE_ORIGINAL": "查看原文",
                        "TRANSLATING": "正在翻译",
                        "FILE_SHARE" : {
                            "DRAG_HERE" : "将文件拖到此处",
                            "UPLOAD_TITLE": "上传文件",
                            "IMAGE": "图像",
                            "PDF": "PDF",
                            "3D_OBJECT": "3D 对象",
                            "OTHER": "其他",
                            "MULTIPLE_OBJECTS": "我们在您的文件中发现了多个对象。 请一次上传一个对象（如果存在则带有纹理）。",
                            "LARGER_THAN": "大于 {{ megabytes }} MB",
                            "FILETYPE_PROHIBITED": "禁止的文件类型",
                            "START_UPLOAD": "上传",
                            "CANCEL_UPLOAD": "停止",
                            "CLOSE_UPLOAD": "关闭",
                            "CANCEL_MODAL_TITLE": "停止上传？",
                            "CANCEL_MODAL_MESSAGE": "这将停止当前的上传。",
                            "CANCEL_MODAL_CLOSE": "取消",
                            "CANCEL_MODAL_CANCEL": "停止"
                        },
                        "DELETE_FILE_MODAL": {
                            "TITLE": "删除文件？",
                            "MESSAGE": "文件将被删除",
                            "CLOSE": "关闭",
                            "DELETE": "删除"
                        },
                        "FILE_DETAILS_MODAL": {
                            "TITLE": "文件详情",
                            "FILENAME": "文件名称",
                            "SIZE": "大小",
                            "TYPE": "类型",
                            "UPLOAD_TIME": "上传时间",
                            "DOWNLOAD": "下载",
                            "CLOSE": "关闭",
                            "FILECOUNT": "总文件数"
                        },
                        "COLLABORATE": "协作",
                        "CLOSE_COLLABORATION": "停止协作",
                        "DOWNLOAD": "下载",
                        "DELETE": "删除",
                        "DETAILS": "详情",
                        "SEND_TO_FILES": "发送到文件",
                        "FILE_DELETED": "文件已删除",
                        "JOIN_ROOM" : "{{ owner_info }} 已加入专室。",
                        "LEAVE_ROOM" : "{{ owner_info }} 已离开专室。",
                        "REACTION": "{{ owner_info }} 发送了一个反应。",
                        "REQUEST_SCREENSHOT": "{{ owner_info }} 已请求快照。",
                        "SHARE_SCREENSHOT" : "{{ owner_info }} 已共享快照。",
                        "SAVED_COLLABORATION": "协作已保存。",
                        "SHARE_IMAGE" : "{{ owner_info }} 共享了一张图片。",
                        "SHARE_PDF" : "{{ owner_info }} 共享了一个 PDF。",
                        "SHARE_OTHER" : "{{ owner_info }} 共享了一个文件。",
                        "SHARE_OBJECT" : "{{ owner_info }} 共享了一个 3D 对象。",
                        "COLLABORATED" : "{{ owner_info }} 已开始协作。",
                        "TYPE_HERE" : "在此输入...",
                        "PLEASE_WAIT_OTHERS": "请等待其他用户加入。",
                        "DOWNLOAD_STARTED_SOON": "下载将很快开始。",
                        "DOWNLOAD_FAILED": "下载失败。",
                        "DOWNLOAD_OBJECT_NOT_SUPPORTED": "尚不支持对像下载。",
                        "DOWNLOAD_NOT_SUPPORTED": "尚不支持下载。",
                        "CLOSE_PREV_COLLABORATION_TITLE": "关闭当前文件协作？",
                        "CLOSE_COLLABORATION_TITLE": "关闭文件协作？",
                        "CLOSE_PREV_COLLABORATION_MESSAGE": "这将关闭当前文件协作并开始一个新的协作。",
                        "CLOSE_COLLABORATION_MESSAGE": "这将关闭文件协作",
                        "CLOSE_PREV_COLLABORATION_YES": "继续",
                        "CLOSE_PREV_COLLABORATION_NO": "取消",
                        "DISABLE_FOCUS_MODAL": {
                            "TITLE": "打开文件协作？",
                            "MESSAGE_AUTHORIZED": "存在固定窗口。 您想取消固定并打开文件协作吗？",
                            "MESSAGE_UNAUTHORIZED": "无法打开文件协作，因为存在固定窗口。",
                            "CANCEL": "取消",
                            "CLOSE": "关闭",
                            "PROCEED": "继续"
                        },
                        "CLOSE_ARPLUS_BEFORE_COLL": {
                            "TITLE": "关闭 AR+？",
                            "MESSAGE": "您需要先关闭 AR+，然後才能打开协作。 您确定要关闭 AR+ 吗？",
                            "NO": "否",
                            "YES": "是"
                        }
                    },
                    "PARTICIPANTS": {
                        "HOST": "（主持人）",
                        "LOWER_ALL_HANDS": "放下所有的手",
                        "RAISED_HAND": "{{ name }} 举手了。",
                        "DENIED_PUBLISH": "{{ name }} 拒绝加入视频/音频通信。",
                        "PARTICIPANT_LIMIT_REACHED": "已达到视频/音频通信参与者限制。",
                        "CALLING": "通话：{{参与者}}"
                    },
                    "FILES": {
                        "INFO_TEXT": "所有有权访问此房间的专家和共同管理员都可以查看和修改此部分中的文件",
                        "DOWNLOAD": "下载",
                        "SEND_TO_SESSION": "发送到会话",
                        "DELETE": "删除",
                        "UPLOAD_FILE": "上传文件",
                        "FILE_CONTENTS": "文件内容：",
                        "FILE_NAME": "文件名：",
                        "FILE_SIZE": "文件大小：",
                        "TOTAL_SIZE": "总尺寸：",
                        "DOWNLOAD_STARTED_SOON": "下载将很快开始。",
                        "DOWNLOAD_FAILED": "下载失败。",
                        "DELETE_MODAL": {
                            "TITLE_DELETE": "删除文件？",
                            "MESSAGE_DELETE": "您确定要删除此文件吗？",
                            "CANCEL": "取消",
                            "DELETE": "删除"
                        }
                    },
                    "SETTINGS": {
                        "MICROPHONE": "麦克风",
                        "CAMERA": "摄像头",
                        "TRANSLATE_OTHERS_MSG_TO": "将其他信息翻译为：",
                        "TRANSLATE_MY_MSG_TO": "将我的信息翻译为：",
                        "CREATE_GUEST_ACCESS": "创建访客访问",
                        "GENERATING": "正在生成",
                        "GUEST_ACCESS": "访客访问",
                        "COPY_LINK": "复制",
                        "LINK_COPIED": "链接已复制到剪贴板。",
                        "LINK_GENERATED": "生成的加入会议链接。",
                        "CANNOT_CREATE_GUEST_ACCESS": "无法创建访客访问。",
                        "NO_LINK_PERMISSION": "您无权创建访客访问链接。请联系您的管理员。",
                        "SHARE": "分享",
                        "SHARE_LINK_VIA_SMS": "通过短信分享链接",
                        "SMS_SEND": "通过短信发送链接",
                        "OPENING": "开幕",
                        "SEND": "发送",
                        "SMS_LIMIT_REACHED": "已达到短信发送限制。请联系您的管理员。",
                        "ERROR_OCCURED": "发生错误。",
                        "SMS_LICENSE_PERMISSION": "您没有发送短信的权限。请联系您的管理员。",
                        "RESHARE": "您可以在一分钟内分享一次链接。",
                        "DIDNT_GET": "没收到链接？",
                        "PHONE_NUMBERS": "最近使用的电话号码",
                        "RESEND": "重发。",
                        "CANCEL": "取消",
                        "CONNECT_VIA_FIELD_CODE": "通过 Field ID 与用户联系",
                        "CONNECT": "连接",
                        "INVITATION_SENT": "邀请已发送给用户。",
                        "INVITATION_COULD_NOT_SENT": "无法将邀请发送给用户。",
                        "FIELD_CODE": "Field ID"
                    }
                },
                "VIDEO_CHAT" : {
                    "AUDIO_BITRATE": "音频比特率",
                    "AUDIO_PACKET_LOSS": "音频丢包",
                    "VIDEO_BITRATE": "视频比特率",
                    "VIDEO_PACKET_LOSS": "视频丢包",
                    "RESOLUTION": "解析度",
                    "WAIT_OTHER_USERS" : "请等待其他用户加入。",
                    "WAIT_EXPERT": "请等待专家加入。",
                    "WAIT_MASTER": "请等待主持人开始会议。",
                    "START_SESSION": "开始会议",
                    "HOST_WITHDRAW_REQUEST": "主机撤回视频/音频请求。",
                    "NO_CAM_MIC": "您的摄像头和麦克风不可用。",
                    "NO_CAM": "您的相机不可用。",
                    "NO_MIC": "您的麦克风不可用。",
                    "JOIN_VIDEO_AUDIO_MODAL": {
                        "TITLE": "加入视频/音频通信？",
                        "MESSAGE": "主持人希望您启用视频/音频。",
                        "DENY": "拒绝",
                        "ACCEPT": "接受"
                    },
                    "PUBLISHER" : {
                        "YOU": "您",
                        "SCREEN_SHARE_MESSAGE": "您正在共享您的屏幕",
                        "STOP_SCREEN_SHARING": "停止共享"
                    },
                    "SUBSCRIBER" : {
                        "APP_NOT_UP_TO_DATE_FOR_STATS": "无法显示网络状态，因为该参与者的应用程序不是最新的。",
                        "SNAPSHOT": "快照",
                        "AR_PLUS": "AR 协作",
                        "SCREENSHOT_REQUESTED": "快照已请求",
                        "VIDEO_NOT_AVAILABLE": "视频不可用",
                        "WEAK_SIGNAL": "信号微弱",
                        "AUDIO_ONLY_MODE": "纯音频模式",
                        "FLASH": "闪光灯",
                        "AR_NOT_AVAILABLE": "AR 不适用於此设备。",
                        "CHARGING": "正在充电",
                        "LOW_BATTERY": "低电量",
                        "CLOSE_AR_PLUS_MODAL": {
                            "TITLE": "关闭 AR+？",
                            "MESSAGE": "您确定要关闭 AR+ 吗？",
                            "NO": "否",
                            "YES": "是"
                        },
                        "DISABLE_FOCUS_MODAL": {
                            "TITLE": "打开 AR+？",
                            "MESSAGE_AUTHORIZED": "存在固定窗口。 您要取消固定并打开 AR+ 吗？",
                            "MESSAGE_UNAUTHORIZED": "AR+ 无法打开，因为存在固定窗口。",
                            "CANCEL": "取消",
                            "CLOSE": "关闭",
                            "PROCEED": "继续"
                        },
                        "REFRESH_SURFACES": "刷新曲面",
                        "AR_PLUS_LOCKED": "AR+ 已锁定。 请先解锁AR+。"
                    },
                    "CONTROL_BAR": {
                        "SHARE_SCREEN": "共享屏幕",
                        "STOP_SHARE": "停止共享",
                        "MIC_OFF": "麦克风",
                        "CAM_OFF": "摄像头",
                        "CAM_MIC_CANT_ACCESS": "我们无法访问您的摄像头或麦克风",
                        "LEAVE_CALL": "离开",
                        "LEAVE_SESSION": "离开会话",
                        "LEAVE_MEETING": "离开会议",
                        "END_SESSION_FOR_ALL": "为所有人结束会议",
                        "END_MEETING_FOR_ALL": "结束全体会议",
                        "ENDCALL_MODAL": {
                            "TITLE_LEAVE": "离开会话？",
                            "TITLE_LEAVE_MEETING": "离开会议？",
                            "TITLE_END_ALL": "为所有人结束会议？",
                            "TITLE_END_ALL_MEETING": "结束所有人的会议？",
                            "MESSAGE_LEAVE": "您确定要离开会话吗？",
                            "MESSAGE_END_ALL": "您确定要结束会话吗？",
                            "MESSAGE_LEAVE_MEETING": "您确定要离开会议吗？",
                            "MESSAGE_END_ALL_MEETING": "您确定要结束会议吗？",
                            "CANCEL": "取消",
                            "END": "结束",
                            "LEAVE": "离开",
                            "REMOVE_MEETING_LINK": "同时禁用并删除会议链接"
                        },
                        "RAISE_HAND": "举手",
                        "LOWER_HAND": "下手",
                        "RECORD": "录制",
                        "AUTO_RECORD": "自动录制",
                        "STOP_RECORD": "停止录制",
                        "CANCEL": "取消请求",
                        "ASK_ARCHIVE_PERMISSION": "请求录制许可",
                        "REACTION": "反应",
                        "EXTENSION_MODAL_TITLE": "需要扩展组件",
                        "EXTENSION_MODAL_MESSAGE": "Google Chrome 需要扩展屏幕共享功能。 请安装扩展组件或使用 Mozilla Firefox",
                        "EXTENSION_MODAL_NO": "取消",
                        "EXTENSION_MODAL_YES": "打开扩展组件页面",
                        "ARCHIVE_NO_PERMISSION": "您没有权限录制此会议。 请联系您的管理员。",
                        "P2P_NO_ARCHIVE": "对等视频通话无法录制。 请联系您的管理员。",
                        "SCREEN_SHARE_UPDATE": "您当前的浏览器版本不支持屏幕共享。 请更新您的浏览器。",
                        "SCREEN_SHARE_NOT_SUPPORTED": "您的浏览器不支持屏幕共享。",
                        "SCREEN_SHARE_USE_OTHER": "您的浏览器不支持屏幕共享。 请使用 Google Chrome 或 Mozilla Firefox。",
                        "SCREEN_SHARE_FAILED": "无法共享屏幕。",
                        "ARCHIVE_REQUESTED": "视频录制将开始。 需要您的许可。",
                        "ARCHIVE_REQUESTED_WITH_NAME": "{{ name }} 想开始视频录制。 需要您的许可。",
                        "DENY": "拒绝",
                        "ALLOW": "允许"
                    },
                    "PDF_COLLABORATION": {
                        "PREVIOUS_PAGE": "上一页",
                        "NEXT_PAGE": "下一页"
                    },
                    "COLLABORATION_SHARED": {
                        "SOME_USERS_CANNOT_LOAD": "某些用户无法加载文件协作。",
                        "DOWNLOAD_FAILED": "无法下载文件协作。",
                        "END_COLL_TITLE": "关闭文件协作？",
                        "END_COLL_MESSAGE": "这将关闭文件协作。",
                        "END_COLL_NO": "取消",
                        "END_COLL_YES": "继续",
                        "ALREADY_ENDED": "文件协作已结束。",
                        "CANNOT_END_COLLABORATION": "无法结束文件协作。",
                        "ANNOTATE": "注释",
                        "FULLSCREEN": "全屏",
                        "DOWNLOAD_COLLABORATION": "下载协作",
                        "SNAPSHOT_COLLABORATION": "快照协作",
                        "UNDO": "复原",
                        "REDO": "反做",
                        "REVERT": "恢复",
                        "RELOAD": "重新加载"
                    },
                    "TRY_TO_FOCUS_MODAL": {
                        "TITLE": "固定窗口？",
                        "MESSAGE": "在 AR+ 模式下无法固定。 关闭 AR+ 并固定？",
                        "CANCEL": "取消",
                        "PROCEED": "继续"
                    }
                }
            },
            "RECONNECT_ROOM": {
                "RECONNECT_MESSAGE": "看起来好像出错了。我们正在努力恢复您的通话。"
            },
            "SESSION_RATING": {
                "BAD": "坏的",
                "POOR": "不足",
                "FAIR": "平均数",
                "GOOD": "好的",
                "EXCELLENT": "优秀",
                "RATING_MESSAGE" : "会议质量如何？",
                "REVIEW_MESSAGE" : "告诉我们原因（可选）",
                "SUCCESS_MESSAGE": "感谢您对会议进行评分。",
                "CLOSE": "关闭",
                "SUBMIT": "提交",
                "DISMISS": "抛弃"
            },
            "PRECALL_TEST": {
                "BACK_TO_LOBBY": "回到大堂",
                "RUN_PRECALL_TEST": "运行预通话测试",
                "WHAT_TEST": {
                    "TITLE": "我们要准备测试",
                    "CONNECTIVITY": "与所有媒体服务器的连接。",
                    "STATS": "收集比特率和丢包统计信息。",
                    "SETUP": "端点上的硬件和软件设置（摄像头丶麦克风丶浏览器）。"
                },
                "BEFORE_START": {
                    "TITLE": "在你开始之前",
                    "MAKE_SURE": "确保;",
                    "RIGHT_NETWORK": "您位於要测试的特定网络上。",
                    "TCP_PORT_OPEN": "您至少打开了 TCP 端口 443。",
                    "RIGHT_HARDWARE": "选择了正确的摄像头和麦克风。",
                    "BANDWITH": "带宽超过350kbps上传和下载。"
                },
                "HARDWARE_SOFTWARE": {
                    "TITLE": "硬件/软件设置",
                    "OPERATING_SYSTEM": {
                        "MESSAGE": "操作系统",
                        "BETTER_ALTERNATIVE_IOS": "您可以从 AppStore 下载 {{ appName }} Remote App 以获得更好的体验。",
                        "BETTER_ALTERNATIVE_ANDROID": "您可以从 Google Play 商店下载 {{ appName }} Remote App 以获得更好的体验。"
                    },
                    "BROWSER": {
                        "MESSAGE": "浏览器",
                        "NOT_SUPPORTED": "不支持您的浏览器。 请使用 Google Chrome丶Mozilla Firefox丶Safari 或 Microsoft Edge（版本 79 或更高版本）。",
                        "NOT_COMPATIBLE": "您的浏览器不兼容。 请更新您的浏览器。",
                        "USE_SAFARI": "您的浏览器不兼容。 请使用 {{ appName }} Remote 应用程序或使用 Safari。"
                    },
                    "HARDWARE": {
                        "MESSAGE": "摄像头/麦克风存取",
                        "CANT_ACCESS": "我们无法存取您的摄像头/麦克风。"
                    }
                },
                "CONNECTION_SERVERS": {
                    "TITLE": "连接到我们的服务器",
                    "INTERNET": {
                        "MESSAGE": "网络连接",
                        "OFFLINE": "您的网络连接似乎处於离线状态。"
                    },
                    "SERVERS": {
                        "MESSAGE": "连接到我们的服务器",
                        "UNKNOWN_ERROR_TRY": "连接到服务器时发生错误。 请稍後再试。",
                        "UNKNOWN_ERROR": "连接到服务器时发生错误。"
                    }
                },
                "QUALITY": {
                    "TITLE": "“音频/视频质量",
                    "AUDIO_VIDEO": {
                        "MESSAGE": "音频/视频质量",
                        "UNKNOWN_ERROR": "测试音频/视频质量时发生错误。",
                        "VIDEO": "视频",
                        "VIDEO_QUALITY": "视频质量： ",
                        "VIDEO_PACKET_LOSS": "数据包丢失： ",
                        "VIDEO_BITRATE": "视频比特率： ",
                        "AUDIO": "音频",
                        "AUDIO_QUALITY": "音频质量： ",
                        "AUDIO_PACKET_LOSS": "数据包丢失： ",
                        "AUDIO_BITRATE": "音频比特率： ",
                        "QUALITY_EXCELLENT": "（优良）",
                        "QUALITY_GOOD": "（良好）",
                        "QUALITY_BAD": "（不良）"
                    }
                },
                "STOP_TEST_MODAL": {
                    "TITLE": "停止测试？",
                    "MESSAGE": "这将停止预通话测试。",
                    "NO": "取消",
                    "YES": "停止"
                }
            },
            "EMAIL_RECIPIENTS": {
                "PLACEHOLDER": "添新",
                "SECONDARY_PLACEHOLDER": "请输入电邮地址",
                "INVALID_EMAIL": "电子邮件格式无效。"
            },
            "WORKFLOW_REMOTE": {
                "ERRORS": {
                    "INTEGRATION_ALREADY_USED": "集成已使用",
                    "MISSING_PARAMETERS": "缺少參數",
                    "CALL_IN_PROGRESS": "通話正在進行中",
                    "USER_IN_ANOTHER_ROOM": "另一個房間的用戶"
                }
            }
        },
        "HELP_CENTER": {
            "TITLE": "{{ appName }} 服务台",
            "TITLE_WITH_REMOTE": "{{ appName }} Remote 服务台",
            "FAILED": "发生错误。"
        },
        "EXTERNALS": {
            "JOIN_WITH_LINK": {
                "TITLE": "{{ appName }} Remote 访客访问",
                "SESSION_NOT_FOUND": "找不到您请求的会议。",
                "SESSION_NOT_AVAILABLE": "此会议已不再可用。",
                "CONCURRENT_LIMIT_REACHED": "已达到并行用户限制。 请联系您的管理员。",
                "EXPERT_CONCURRENT_LIMIT_REACHED": "已达到并行专家用户限制。 请联系您的管理员。",
                "UNKNOWN_ERROR": "哎呀！出了错！",
                "ABOUT_TO_JOIN": "你即将加入 ",
                "ENTER_NAME": "输入你的名称",
                "NAME_REQUIRED": "名称是必需的",
                "NAME_SHORT": "名称必须至少为 2 个字符",
                "JOIN": "加入",
                "CONTINUE_TO_WEBSITE": "通过浏览器继续"
            },
            "ARCHIVE_LIST": {
                "TITLE": "视频通话记录",
                "LOADING": "加载中",
                "LOAD_FAILED": "发生错误。",
                "CREATED_AT": "创建於",
                "SIZE": "大小",
                "STATUS": "状态",
                "DOWNLOAD": "下载",
                "GENERATING": "生成链接",
                "CLICK_TO_DOWNLOAD": "点击下载",
                "AVAILABLE": "可用",
                "DISCONNECTED": "已中断",
                "DELETED": "已删除",
                "EXPIRED": "已到期",
                "WAITING": "等待中",
                "FAILED": "已失败"
            },
            "AUTHENTICATE": {
                "MESSAGE": "发生错误。"
            },
            "AD_LOGIN": {
                "MESSAGE": "发生错误。"
            },
            "AD_ERROR": {
                "ACCOUNT_NOT_FOUND": "你的帐户未连接到 Azure AD。",
                "PERMISSION_DENIED": "您无权查看此页面。",
                "INTERNAL_ERROR": "发生错误。",
                "CONTACT_MAIL": "请联系<strong>{{ contactMail }}</strong>"
            }
        },
        "TUTORIALS": {
            "TUTORIAL_LINK": "显示用户教程",
            "NEXT": "下一个",
            "END": "结束",
            "MIC_CAMERA": "打开/关闭麦克风或摄像头",
            "END_CALL": "离开会话",
            "RECORD": "开始/停止所有会议的录制",
            "SCREEN_SHARING": "开始/停止屏幕共享以向其他用户展示您的操作",
            "REACTION": "给大家发个反应，语音交流不够用的时候有用",
            "OPEN_AR_PLUS": "打开 AR+",
            "DRAW_ON_SURFACE": "使用 AR+ 在实时流中以蓝色网格突出显示的表面上绘图",
            "OPEN_AR": "打开 AR",
            "HOLD_TO_HIGHLIGHT": "单击并按住任意位置以使用 AR 突出显示实时信息流中的特定区域",
            "TAKE_SNAPSHOT": "从其他用户那里拍摄高质量的快照",
            "NO_CAMERA": "其他参与者的摄像头必须打开",
            "WAIT_OR_SKIP": "等待其他用户或跳过此功能",
            "COLLABORATE": "协作处理快照：草图丶放置图表丶特殊形状丶文本",
            "OPEN_ANNOTATION": "打开注释",
            "SKETCH_ON_COLL": "在协作窗格上绘制草图",
            "END_TUTORIAL": "您可以随时从这里访问本教程",
            "USER_TUTORIAL": "用户教程",
            "GUIDE": "本用户教程将指导您逐步完成平台",
            "DONT_SHOW": "不再显示",
            "SKIP_TUTORIAL": "跳过教程",
            "CANCEL": "取消",
            "SKIP": "跳过",
            "ASK_AGAIN": "您确定要跳过本教程吗？"
        },
        "NOT_FOUND": {
            "PAGE_NOT_FOUND": "很抱歉，无法找到您请求的页面。",
            "NO_LONGER_AVAILABLE": "URL 可能拼写错误或您要查找的页面不再可用。"
        },
        "DOWNLOADS": {
            "FILE_NOT_FOUND": "文件未找到",
            "IF_DOWNLOAD_NOT_STARTED": "如果尚未开始下载，",
            "CLICK_HERE": "请单击此处"
        },
    "PAGINATOR": {
        "ITEMS_PER_PAGE": "每页项数:",
        "NEXT_PAGE": "下一页",
        "PREVIOUS_PAGE": "上一页",
        "FIRST_PAGE": "第一页",
        "LAST_PAGE": "最后一页",
        "RANGE": "第 {{start}} – {{end}} 项，共 {{length}} 项",
        "RANGE_ZERO": "共 {{length}} 项"
    }
}